<div appClickOutside [ngClass]="{ 'select-host': isHeadless }" (clickOutside)="onEscKey($event)">
  <a
    *ngIf="isHeadless"
    class="select-wrapper__headless-container"
    href="#"
    role="button"
    (click)="onClick($event)"
    (keydown.arrowdown)="onArrowDown($event)"
    (keydown.arrowup)="onArrowUp($event)"
    (keyup.enter)="onEnterKey($event)"
    (keyup.esc)="onEscKey($event)"
  >
    <!-- [ngClass]="{ 'select-wrapper__headless-container--active': isActive }" -->
    <span class="headless-container__sort-label">
      {{ 'pdp.sort-by-label' | translate }}
      <span class="headless-container__sort-value">
        {{ selectedItem?.[keyProperty] || 'pdp.sort-value' | translate }}
      </span>
      <i class="fa-light fa-arrow-down-arrow-up headless-container__sort-icon"></i>
    </span>
  </a>
  <div
    [class]="
      'select-wrapper' +
      (cssModifier ? ' select-field--' + cssModifier : '') +
      '' +
      (!isActive && cssErrorClass ? ' select-field--' + cssErrorClass : '')
    "
    [ngClass]="{
      'select-wrapper--active': isActive,
      'select-wrapper--headless': isHeadless
    }"
  >
    <div
      *ngIf="!isHeadless"
      class="select-wrapper__field-container"
      [ngClass]="{ 'select-wrapper__field-container--no-results': !filteredItems?.length }"
    >
      <div class="input-icon input-icon--left">
        <i class="fa-light fa-search-location"></i>
      </div>

      <div
        class="input-icon"
        [ngClass]="{
          'input-icon--hidden': isActive,
          'input-icon--right': !isActive,
          'input-icon--invalid': !fieldControl.valid && !fieldControl.pristine && hasSecondaryIcon
        }"
        (click)="toggleActive()"
      >
        <i class="fa-light fa-chevron-down"></i>
      </div>
      <span
        class="input-clear-btn"
        [ngStyle]="{ display: isActive && searchInput.value ? null : 'none' }"
        (click)="onClear()"
      >
        <i class="fa-light fa-circle-xmark"></i>
      </span>
      <input
        #searchInput
        class="input--left-icon"
        type="text"
        data-hj-suppress
        [id]="id"
        [name]="'selectInputField' + (name ? '-' + name : '')"
        [formControl]="fieldControl"
        [required]="required"
        [tabindex]="tabIndex"
        (click)="toggleActive()"
        (keydown.arrowdown)="onArrowDown($event)"
        (keydown.arrowup)="onArrowUp($event)"
        (keydown.tab)="onTabKey($event)"
        (keydown.shift.tab)="onTabKey($event)"
        (keydown.enter)="onEnterKey($event)"
        (keydown.esc)="onEscKey($event)"
      />
      <label *ngIf="label" [for]="id">{{ label }}</label>
    </div>

    <div
      *ngIf="isHeadless && isActive && !isMobile"
      class="select-wrapper__list-container"
      [ngClass]="{ 'select-wrapper__list-container--headless': true }"
    >
      <ng-container *ngTemplateOutlet="listTemplate" />
    </div>
    <div
      *ngIf="!isHeadless && (isReadyToRenderListItems || isActive)"
      #simpleScrollBar
      class="select-wrapper__list-container"
      data-simplebar
    >
      <ng-container *ngTemplateOutlet="listTemplate" />
    </div>
  </div>

  <app-info-modal
    *ngIf="modalVars[selectFieldModalId]"
    class="lm-modal select-field-modal"
    id="select-field-picker"
    [modalOptions]="{
      fullScreen: false,
      modalSize: 'modal-sm'
    }"
    (closeModal)="closeModal(selectFieldModalId, true)"
  >
    <h2 class="lm-modal__title select-field-modal__header h4--secondary">{{ 'pdp.sort-by-label' | translate }}</h2>
    <ng-container *ngTemplateOutlet="listTemplate; context: { additionalClasses: 'select-field-modal__body' }" />
  </app-info-modal>

  <ng-template #listTemplate let-additionalClasses="additionalClasses || ''">
    <ul
      *ngIf="filteredItems"
      [class]="'list-container__list' + (' ' + additionalClasses)"
      (mouseenter)="highlightedItem = null"
    >
      <ng-container *ngFor="let item of filteredItems; let i = index; trackBy: trackBySelectField">
        <li
          class="list__item"
          [attr.data-value]="item?.[valueProperty]"
          [ngClass]="{
            'list__item--selected-previous': selectedItemIndex > 0 && i === selectedItemIndex - 1,
            'list__item--selected': item?.[valueProperty] === selectedItem?.[valueProperty],
            'list__item--highlight': i === highlightedItemIndex,
            'list__item--disabled': !checkEnabled(item)
          }"
          (click)="onSelectItem(item)"
        >
          <i
            *ngIf="item?.[valueProperty] === selectedItem?.[valueProperty]"
            class="list__item-icon-search fa-light fa-search-location"
          ></i>
          <span *ngIf="!debugging" class="list__item-label">
            {{ item?.[keyProperty] || item?.name }}
          </span>
          <span *ngIf="debugging">{{ item | json }}</span>
          <i
            *ngIf="item?.[valueProperty] === selectedItem?.[valueProperty]"
            class="list__item-icon-check fa-light fa-check"
          ></i>
        </li>
      </ng-container>
    </ul>
  </ng-template>
</div>
